import {
  Component,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { IMaerskLocation } from "app/location/maersk-location.model";
import { BaseStandardQuote } from "app/quote/models/quote-base-standard.model";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Dialog } from "primeng/dialog";
import { MaerskLocationSelectComponent } from "../../ui/dropdown/maersk-location-select/maersk-location-select.component";

@Component({
  selector: "app-quote-maersk-locations",
  templateUrl: "./quote-maersk-locations.component.html",
  styleUrls: ["./quote-maersk-locations.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonDirective, Bind, Dialog, MaerskLocationSelectComponent],
})
export class QuoteMaerskLocationsComponent implements OnInit {
  public readonly quote = input<BaseStandardQuote>(undefined);
  readonly closeView = output();
  readonly fetchRates = output<{
    originGeoId: string | null;
    destinationGeoId: string | null;
  }>();

  public originCountry: string;
  public originLocation: IMaerskLocation;
  public destinationCountry: string;
  public destinationLocation: IMaerskLocation;

  constructor() {}

  ngOnInit(): void {
    if (this.quote().getOriginLocations().length) {
      this.originCountry = this.quote().getOriginLocations()[0].country;
    }
    if (this.quote().getDestinationLocations().length) {
      this.destinationCountry =
        this.quote().getDestinationLocations()[0].country;
    }
  }

  public save() {
    this.fetchRates.emit({
      originGeoId: this.originLocation?.carrierGeoID,
      destinationGeoId: this.destinationLocation?.carrierGeoID,
    });
  }

  public close() {
    this.closeView.emit();
  }
}
